import {createInstance} from '../../js/iwan/basePano'
import './style.scss'

// https://www.archdaily.com/897150/institute-of-contemporary-art-diller-scofidio-plus-renfro

const map = {
  level1: {
    name: 'LEVEL 1'
    ,mapspots: [
       { x:-40,y:1,target:'pano01' }
      ,{ x:0,y:0,target:'pano02' }
      ,{ x:0,y:-30,target:'pano03' }
      ,{ x:0,y:-60,target:'pano04' }
      ,{ x:40,y:1,target:'pano05' }
    ].map(spot=>{
      spot.x = spot.x - 50 + 150
      spot.y = spot.y - 40 + 128
      return spot
    })/*.map((spot,i)=>{
      spot.x = - 80 + i * 40
      return spot
    })*/
  }
}

const inst = createInstance('panoica','./data/ica/krpano.xml','pano01',map)
inst.map.classList.add('map--align-right')


// WEBPACK FOOTER //
// ./src/data/ica/main.js